import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ProtectedRoute from './ProtectedRoute';

import Landing from '../Screens/Landing';
import Login from '../Screens/Login';
import Dashboard from '../Screens/Dashboard';
import NotFound from '../Screens/NotFound';
import ForgotScreen from '../Screens/Forgot';
import VerifyUser from '../Screens/VerifyUser';

const Router = ({ token }) => {
  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <ProtectedRoute
        exact
        path="/login"
        component={Login}
        token={token === '' ? '1' : ''}
        redirect={{
          pathname: '/dashboard',
          state: {
            key: 'dashboard',
          },
        }}
      />
      <ProtectedRoute
        path="/dashboard"
        component={Dashboard}
        token={token}
        redirect={{
          pathname: '/login',
          state: {
            key: 'login',
          },
        }}
      />
      <ProtectedRoute
        exact
        path="/forgot"
        component={ForgotScreen}
        token={token === '' ? '1' : ''}
        redirect={{
          pathname: '/dashboard',
          state: {
            key: 'dashboard',
          },
        }}
      />
      <Route component={VerifyUser} path="/verify" />
      <Route component={NotFound} />
    </Switch>
  );
};

const mapStateStore = (state) => {
  return {
    token: state.auth.token,
    location: state.router.location,
  };
};

const mapStateFunc = { navigatePush: push };

Router.propTypes = {
  token: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect(mapStateStore, mapStateFunc)(Router);
